package com.zq.webproject.ui.order

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import coil3.compose.AsyncImage
import com.zq.webproject.utils.UrlLauncher

/**
 * JS平台二维码图片视图
 * 使用 Coil AsyncImage 加载代理图片，失败后提供降级方案
 */
@Composable
actual fun QrcodeImageView(imageUrl: String) {
    println("QrcodeImageView - JS平台加载二维码图片: $imageUrl")
    
    var isLoading by remember { mutableStateOf(true) }
    var isError by remember { mutableStateOf(false) }
    
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        // 显示错误降级方案
        if (isError) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    "二维码加载失败",
                    color = Color.Red
                )
                Spacer(modifier = Modifier.height(8.dp))
                Button(
                    onClick = {
                        println("QrcodeImageView - 点击在新窗口打开二维码")
                        UrlLauncher.openUrl(imageUrl)
                    }
                ) {
                    Text("点击查看二维码")
                }
            }
        }
        
        // 显示加载指示器
        if (isLoading && !isError) {
            CircularProgressIndicator(
                modifier = Modifier.size(48.dp)
            )
        }
        
        // 使用 AsyncImage 加载
        AsyncImage(
            model = imageUrl,
            contentDescription = "支付二维码",
            modifier = Modifier.fillMaxSize(),
            onSuccess = {
                println("QrcodeImageView - ✅ 二维码图片加载成功")
                isLoading = false
                isError = false
            },
            onError = {
                println("QrcodeImageView - ❌ 二维码图片加载失败: ${it.result.throwable.message}")
                isLoading = false
                isError = true
            }
        )
    }
}
